module.exports = __webpack_public_path__ + "assets/img/icon-3.65c35d7e.png";